import { render } from "./AnnouncementModal.vue?vue&type=template&id=175e7564&scoped=true"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"

import "./AnnouncementModal.vue?vue&type=style&index=0&id=175e7564&scoped=true&lang=css"

import exportComponent from "/var/www/gigs.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175e7564"]])

export default __exports__